import { handleActions } from 'redux-actions';
import { completeWithError } from 'data/qcsSyncResourceReducerHelpers';

import { InvestmentHoldingsStore } from './types';
import * as actions from './actions';

import { upsertIHolds } from './reducerHelpers';

// const log = getLogger('data/investmentHoldings/reducer.js');
export const INVESTMENT_HOLDINGS_REDUCER_KEY = 'investmentHoldingsStore';

const reducer = handleActions({

  // Called when triggering a CRUD operation on transactions. Sagas are also
  // expected to handle the action by initiating the CRUD operation wiht QCS.
  //
  [actions.getInvestmentHoldings]: (state) => state.merge({ isLoading: true }),
  [actions.getInvestmentHoldingsSuccess]: (state, { payload: data }) => upsertIHolds(state, data),
  [actions.getInvestmentHoldingsFailure]: (state, { payload: error }) => completeWithError(state, error),

}, new InvestmentHoldingsStore());

export default reducer;
